import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../components/modal-custom'

import { Button, Col, Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LabelCustom from '../../../components/label-custom'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import { fnDateEn } from '../../../helper/fnDateEn'

export default function ModalMoreFilter({
  open,
  onCancel,
  fnGetData,
  bodyFilter
}) {
  const [isSubmit, setIsSubmit] = useState(false)
  const { control, setValue, handleSubmit } = useForm()

  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  useEffect(() => {
    const d = bodyFilter
    d?.insertBy && setValue('insertBy', d.insertBy)
    d?.insertDate && setValue('insertDate', d.insertDate)
    d?.periodEndDate && setValue('periodEndDate', d.periodEndDate)
    d?.periodStartDate && setValue('periodStartDate', d.periodStartDate)
  }, [open])

  const onSubmit = async (d) => {
    const body = {
      page: 1,
      periodStartDate: d.periodStartDate
        ? fnDateEn(d.periodStartDate).format('YYYY-MM-DD')
        : '',
      periodEndDate: d.periodEndDate
        ? fnDateEn(d.periodEndDate).format('YYYY-MM-DD')
        : '',
      insertDate: d.insertDate
        ? fnDateEn(d.insertDate).format('YYYY-MM-DD')
        : '',
      insertBy: d.insertBy
    }
    setIsSubmit(true)
    fnGetData(body)
    onCancel()
    setIsSubmit(false)
  }

  return (
    <ModalCustom open={open} onCancel={onCancel}>
      <div>
        <h5>More Filter</h5>
        <Form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
          <Col xl={6}>
            <LabelCustom text={'Periods Start Date'} />
            <Controller
              name={'periodStartDate'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <CustomDatePicker
                  maxDate={endDate}
                  showYearDropdown
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  value={value}
                  onChange={(e) => {
                    onChange(e)
                    setStartDate(e)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={6}>
            <LabelCustom text={'Periods End Date'} />
            <Controller
              name={'periodEndDate'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <CustomDatePicker
                  minDate={startDate}
                  showYearDropdown
                  showMonthYearPicker
                  dateFormat="MM/yyyy"
                  value={value}
                  onChange={(e) => {
                    onChange(e)
                    setEndDate(e)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={6}>
            <LabelCustom text={'insertDate'} />
            <Controller
              name={'insertDate'}
              control={control}
              render={({ field: { onChange, value = null } }) => (
                <CustomDatePicker
                  showYearDropdown
                  showMonthDropdown
                  value={value}
                  onChange={(date) => {
                    onChange(date)
                  }}
                />
              )}
            />
          </Col>
          <Col xl={6}>
            <LabelCustom text={'insertBy'} />
            <Controller
              name={'insertBy'}
              control={control}
              render={({ field: { onChange, value = '' } }) => (
                <Form.Control
                  value={value}
                  onChange={(date) => {
                    onChange(date)
                  }}
                />
              )}
            />
          </Col>

          <Col className="text-center mt-4">
            <Button variant="light" onClick={onCancel} className="me-2 px-4">
              Close
            </Button>
            <Button disabled={isSubmit} type="submit" className=" px-4">
              Submit{isSubmit && 'ting...'}
            </Button>
          </Col>
        </Form>
      </div>
    </ModalCustom>
  )
}
